// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BusinessAdmin_upper__EkX8t {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media only screen and (max-width: 43.75em) {
  .BusinessAdmin_upper__EkX8t {
    display: grid;
    grid-template-columns: min-content max-content;
    gap: 1rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .BusinessAdmin_upper__EkX8t {
    grid-template-columns: min-content max-content;
    gap: 1rem;
  }
  .BusinessAdmin_upper__EkX8t > :nth-child(2) {
    grid-row: 1/2;
    grid-column: 1/3;
    justify-self: center;
  }
}
@media only screen and (max-width: 43.75em) {
  .BusinessAdmin_upper__EkX8t > :last-child {
    grid-column: 2/3;
    justify-self: end;
  }
}

.BusinessAdmin_main__LvkY7 {
  margin-top: 3rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .BusinessAdmin_main__LvkY7 {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 31.25em) {
  .BusinessAdmin_main__LvkY7 {
    grid-template-columns: repeat(2, 1fr);
  }
}

.BusinessAdmin_ba__num__bDVp- {
  width: 18rem;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 6rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.BusinessAdmin_ba__card__4tGCW {
  background-color: var(--color-white);
  height: 25rem;
  width: 100%;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15);
}
.BusinessAdmin_ba__card__4tGCW:hover {
  border: 2px solid var(--color-primary);
  background: linear-gradient(to right bottom, var(--color-white), var(--color-light) 100%);
}
.BusinessAdmin_ba__card__4tGCW > :not(:last-child) {
  margin-bottom: 1rem;
}
.BusinessAdmin_ba__card__4tGCW img {
  height: 6rem;
}
.BusinessAdmin_ba__card_btn__80wbO {
  width: 90%;
  background-color: var(--color-dark);
  color: var(--color-white);
  font-size: var(--default-font-small);
  font-weight: 700;
  text-align: center;
  padding: 0.5rem 1rem;
  border-radius: 0.8rem;
  cursor: pointer;
}
.BusinessAdmin_ba__card_btn__80wbO:hover {
  background-color: var(--color-dark-2);
}
.BusinessAdmin_ba__permits__lnmGQ {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  width: 38rem;
  padding-left: 2rem;
}
.BusinessAdmin_ba__permits__lnmGQ > * {
  margin-bottom: 1rem;
}
.BusinessAdmin_ba__permits_middle__YmnC0 {
  display: flex;
  width: 38rem;
  justify-content: center;
  margin-top: 2rem;
}
.BusinessAdmin_ba__permits_list__dNs6h {
  width: 38rem;
  display: flex;
  flex-direction: column;
  font-size: var(--default-font-small);
  margin-bottom: 2rem;
}
.BusinessAdmin_ba__permits_list__dNs6h > * {
  margin-right: 2rem;
}

.BusinessAdmin_checks__7Zs2A {
  width: 38rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.BusinessAdmin_error__BcHVR {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}

.BusinessAdmin_table__FcqoJ {
  width: 38rem;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.BusinessAdmin_table__FcqoJ tr {
  display: grid;
  grid-template-columns: 100%;
  align-items: center;
  padding: 1rem 2rem;
  cursor: pointer;
}
.BusinessAdmin_table__FcqoJ tr > :first-child {
  font-weight: 700;
}
.BusinessAdmin_table__FcqoJ tbody > :not(:last-child) {
  margin-bottom: 1rem;
}
.BusinessAdmin_table__FcqoJ tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.BusinessAdmin_table__FcqoJ tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
  border-radius: 1.3rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/BusinessAdmin/BusinessAdmin.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AADD;AAEC;EAJD;IAKE,aAAA;IACA,8CAAA;IACA,SAAA;EACA;AACF;AACC;EAVD;IAWE,8CAAA;IACA,SAAA;EAEA;EACD;IAEE,aAAA;IACA,gBAAA;IACA,oBAAA;EAED;AANF;AASE;EADD;IAEE,gBAAA;IACA,iBAAA;EACD;AACF;;AAGA;EACC,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AAAD;AAEC;EAND;IAOE,qCAAA;EACA;AACF;AAAC;EATD;IAUE,qCAAA;EAGA;AACF;;AACC;EACC,YAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;AAEF;AACC;EACC,oCAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;AACF;AACE;EACC,sCAAA;EACA,yFAAA;AACH;AAME;EACC,mBAAA;AAJH;AAOE;EACC,YAAA;AALH;AAQE;EACC,UAAA;EACA,mCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;AANH;AAQG;EACC,qCAAA;AANJ;AAYC;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAVF;AAYE;EACC,mBAAA;AAVH;AAaE;EACC,aAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;AAXH;AAcE;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;AAZH;AAcG;EACC,kBAAA;AAZJ;;AAmBA;EACC,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAhBD;;AAmBA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAhBD;;AAmBA;EACC,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAhBD;AAkBC;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAhBF;AAkBE;EACC,gBAAA;AAhBH;AAqBE;EACC,mBAAA;AAnBH;AAsBE;EACC,wCAAA;EACA,qBAAA;AApBH;AAsBG;EACC,wCAAA;EACA,qBAAA;AApBJ","sourcesContent":["@import '../variables/breakpoints';\n\n.upper {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\t@media only screen and (max-width: $bp-700) {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: min-content max-content;\n\t\tgap: 1rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-template-columns: min-content max-content;\n\t\tgap: 1rem;\n\t}\n\n\t& > :nth-child(2) {\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tgrid-row: 1/2;\n\t\t\tgrid-column: 1/3;\n\t\t\tjustify-self: center;\n\t\t}\n\t}\n\n\t& > :last-child {\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tgrid-column: 2/3;\n\t\t\tjustify-self: end;\n\t\t}\n\t}\n}\n\n.main {\n\tmargin-top: 3rem;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, 1fr);\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t}\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n.ba {\n\t&__num {\n\t\twidth: 18rem;\n\t\tbackground-color: var(--color-white);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\theight: 6rem;\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t}\n\n\t&__card {\n\t\tbackground-color: var(--color-white);\n\t\theight: 25rem;\n\t\twidth: 100%;\n\t\tborder-radius: 1rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbox-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15);\n\n\t\t&:hover {\n\t\t\tborder: 2px solid var(--color-primary);\n\t\t\tbackground: linear-gradient(\n\t\t\t\tto right bottom,\n\t\t\t\tvar(--color-white),\n\t\t\t\tvar(--color-light) 100%\n\t\t\t);\n\t\t}\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\timg {\n\t\t\theight: 6rem;\n\t\t}\n\n\t\t&_btn {\n\t\t\twidth: 90%;\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tfont-weight: 700;\n\t\t\ttext-align: center;\n\t\t\tpadding: 0.5rem 1rem;\n\t\t\tborder-radius: 0.8rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-dark-2);\n\t\t\t\t// box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.12);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__permits {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmargin-top: 2rem;\n\t\twidth: 38rem;\n\t\tpadding-left: 2rem;\n\n\t\t& > * {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\t&_middle {\n\t\t\tdisplay: flex;\n\t\t\twidth: 38rem;\n\t\t\tjustify-content: center;\n\t\t\tmargin-top: 2rem;\n\t\t}\n\n\t\t&_list {\n\t\t\twidth: 38rem;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tmargin-bottom: 2rem;\n\n\t\t\t& > * {\n\t\t\t\tmargin-right: 2rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n//checkbox\n.checks {\n\twidth: 38rem;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 2rem;\n}\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n}\n\n.table {\n\twidth: 38rem;\n\tborder: none;\n\tborder-collapse: collapse;\n\tbox-sizing: border-box;\n\ttext-align: left;\n\tfont-size: var(--default-font-small);\n\n\ttr {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 100%;\n\t\talign-items: center;\n\t\tpadding: 1rem 2rem;\n\t\tcursor: pointer;\n\n\t\t& > :first-child {\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n\n\ttbody {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\ttr {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tborder-radius: 1.3rem;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tborder-radius: 1.3rem;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper": `BusinessAdmin_upper__EkX8t`,
	"main": `BusinessAdmin_main__LvkY7`,
	"ba__num": `BusinessAdmin_ba__num__bDVp-`,
	"ba__card": `BusinessAdmin_ba__card__4tGCW`,
	"ba__card_btn": `BusinessAdmin_ba__card_btn__80wbO`,
	"ba__permits": `BusinessAdmin_ba__permits__lnmGQ`,
	"ba__permits_middle": `BusinessAdmin_ba__permits_middle__YmnC0`,
	"ba__permits_list": `BusinessAdmin_ba__permits_list__dNs6h`,
	"checks": `BusinessAdmin_checks__7Zs2A`,
	"error": `BusinessAdmin_error__BcHVR`,
	"table": `BusinessAdmin_table__FcqoJ`
};
export default ___CSS_LOADER_EXPORT___;
